module.exports = __webpack_public_path__ + "static/sliderm_2-b5d551b8743715e5d581aa5e1172cb60.jpg";